import { FC } from "react";

export const CloseIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      height="18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10.312 8.319"
      className={className || ""}
    >
      <path d="M6.073 4.078 10.151 0H9.093A1.87 1.87 0 0 0 7.77.548L5.157 3.162 2.543.548A1.87 1.87 0 0 0 1.22 0H.161L4.24 4.078 0 8.318h1.058a1.87 1.87 0 0 0 1.322-.547l2.777-2.777 2.776 2.777a1.869 1.869 0 0 0 1.322.548h1.058Z" />
    </svg>
  );
};
